<template>
  <div class="rating">
    <Header>
      <div
        class="rating-header__block width-100"
        style="justify-content: unset"
      >
        <UiSelectFilter
          class="rating-header__item -m-"
          title="Выбор потока"
          placeholder="Ничего не выбрано"
          :option="courseList"
          :value="filter.course"
          :can-unset="true"
          :smart="true"
          unset-text="Все потоки"
          :max-height="200"
          @input="changeValue($event, 'stream')"
        />
        <UiCheckbox
          :value="filter.onlyWithoutVerified"
          @input="changeValue($event, 'onlyWithoutVerified')"
        >
          Нет подтвержденной ниши
        </UiCheckbox>
        <div v-if="totalCount > 0" class="rating-header__item member-count">
          {{ totalCount }}
          {{ declination(totalCount, ['участник', 'участника', 'участников']) }}
        </div>
      </div>
    </Header>
    <InvestmentsTable
      :sort-channel="filter.sort.channelId"
      :stream-filter="filter.stream"
      :filter="filter"
      :nav-titles="navTitles"
      @setSort="setSort"
    />
  </div>
</template>

<script>
import Header from '../components/Header';
import InvestmentsTable from './components/InvestmentsTable';
import { mapGetters, mapState } from 'vuex';
import _ from 'lodash';
import replaceRouteQuery from '@/functions/replaceMultipleRouteQuery';
import declinationOfNum from '@/functions/declinationOfNum';

export default {
  components: {
    Header,
    InvestmentsTable
  },
  data: () => ({
    filter: {
      userName: undefined,
      stream: undefined,
      city: undefined,
      onlyWithoutVerified: false,
      sort: {
        channelId: undefined,
        sortType: undefined
      }
    },
    navTitles: [
      {
        title: 'Имя',
        id: 1,
        width: '2fr'
      },
      {
        title: 'Город',
        id: 2,
        width: '1fr'
      },
      {
        title: 'Ниша',
        id: 3,
        width: '2.3fr'
      },
      {
        title: 'Точка А',
        id: 4,
        width: '1fr',
        channelId: 'pointA',
        sortType: 'DESC'
      },
      {
        title: 'Чистая прибыль',
        id: 5,
        width: '1.3fr'
      },
      {
        title: 'Встречи',
        id: 6,
        width: '1fr',
        channelId: 'totalPassed',
        sortType: 'DESC'
      },
      {
        title: 'Привлечено',
        id: 7,
        width: '1fr',
        channelId: 'totalAmount',
        sortType: 'DESC'
      }
    ]
  }),
  computed: {
    ...mapGetters('ratingInvestments', {
      courseList: 'courseList',
      cityList: 'cityList'
    }),
    ...mapState('ratingInvestments', {
      totalCount: s => s.data.totalCount
    }),
    ...mapState('auth', {
      isAdmin: s => s.data.user.permissions.isAdmin,
      user: s => s.data.user,
      isLoadingUser: s => s.meta.loading
    })
  },
  watch: {
    '$route.query'() {
      this.getUserTotal();
      this.getUserList();
    }
  },
  async created() {
    await this.getSettings();
    this.getUserTotal();
    this.getUserList();
  },
  methods: {
    initFilter() {
      const query = this.$route.query;
      const filter = this.filter;

      filter.userName = query['name'] || filter.userName;
      filter.city = query['city'] || filter.city;
      filter.stream = +query['stream'] || filter.stream;
      filter.stream = +query['onlyWithoutVerified'] || filter.stream;

      filter.sort.channelId = query['channelId'] || filter.channelId;
      filter.sort.sortType = query['sortType'] || filter.sortType;

      if (query['channelId'] !== undefined && query['sortType'] !== undefined) {
        this.changeSort({
          channelId: +query['channelId'],
          sortType: +query['sortType']
        });
      }
    },
    openUser(id) {
      this.$router.push(`/rating/investments/user/${id}`);
    },
    getUserList() {
      this.$store.dispatch('ratingInvestments/getUserList', this.filter);
    },
    getUserTotal() {
      this.$store.dispatch('ratingInvestments/getUsersCount', {
        stream: this.filter.stream,
        onlyWithoutVerified: this.filter.onlyWithoutVerified,
        city: this.filter.city,
        name: this.filter.userName
      });
    },
    getSettings() {
      this.$store.dispatch('ratingInvestments/getSettings');
    },
    setSort({ channelId, sortType, id }) {
      if (channelId !== this.filter.sort.channelId) {
        this.changeSort({ channelId });
        this.multipleChangeValue({ channelId: channelId, sortType });
      } else {
        const idx = this.navTitles.findIndex(nav => nav.id === id);
        this.changeSort({
          channelId,
          sortType: sortType === 'ASC' ? 'DESC' : 'ASC'
        });
        this.multipleChangeValue({
          channelId: channelId,
          sortType: this.navTitles[idx].sortType
        });
      }
    },
    changeValue(value, name) {
      const obj = {};

      obj[name] = value;
      this.filter[name] = value;

      const arrQuery = Object.entries({ ...this.$route.query, ...obj }).map(
        el => ({
          method: 'replace',
          name: el[0],
          value: el[1]
        })
      );

      if (this.checkRouterEqual(arrQuery)) {
        return;
      }
      replaceRouteQuery(arrQuery);
    },
    changeValueDebounced: _.debounce(function (event) {
      this.changeValue(event, 'name');
    }, 500),
    multipleChangeValue(params) {
      const arrQuery = Object.entries({ ...this.$route.query }).map(el => ({
        method: 'replace',
        name: el[0],
        value: el[1]
      }));

      arrQuery.forEach(q => {
        if (
          q.name === 'sort[pointA]' ||
          q.name === 'sort[totalPassed]' ||
          q.name === 'sort[totalAmount]'
        ) {
          q.value = '';
        }
      });

      arrQuery.push({
        method: 'replace',
        name: `sort[${params.channelId}]`,
        value: params.sortType
      });

      if (this.checkRouterEqual(arrQuery)) {
        return;
      }
      replaceRouteQuery(arrQuery);
    },
    checkRouterEqual(arrQuery) {
      return !arrQuery.find(
        param => param.value !== this.$route.query[param.name]
      );
    },
    changeSort({ channelId, sortType }) {
      if (channelId !== undefined) {
        this.filter.sort.channelId = channelId;
      }

      if (channelId !== undefined && sortType !== undefined) {
        const idx = this.navTitles.findIndex(
          nav => nav.channelId === channelId
        );
        if (idx === -1) {
          return;
        }
        this.navTitles[idx].sortType = sortType;
        this.filter.sort.sortType = sortType;
      }
    },
    declination(num, words) {
      return declinationOfNum(num, words);
    }
  }
};
</script>
